import { useImperativeHandle, useState } from "react";
import { ModalProps, IModalRefProps } from "./types";

export const useModalController = ({ ref }: Pick<ModalProps, "ref">) => {
  const [isOpen, setIsOpen] = useState(false);

  useImperativeHandle(
    ref,
    (): IModalRefProps => ({
      open: () => {
        setIsOpen(true);
      },
      close: () => setIsOpen(false)
    }),
    []
  );

  const handleClose = () => {
    setIsOpen(false);
  };

  return { isOpen, handleClose };
};
